import * as React from 'react';
import { throttle } from 'throttle-debounce';

import { isElementInViewport } from '../../../utils/isElementInViewport';
import { IScrollingContext } from '../types';
import { MostClosestToCenterCalculator } from './mostClosestToCenterCalculator';

const SCROLL_WATCH_HANDLER_THROTTLE_MS = 350;

/*
 * Следит за скроллингом страницы и отмечает, какой из блоков пользователь видит на экране
 * */
/* istanbul ignore next */
export const useWatchBlocks = (context: IScrollingContext) => {
  const { refBlocksState, setActive, viewed, setViewed } = context;

  React.useEffect(() => {
    const handler = throttle(SCROLL_WATCH_HANDLER_THROTTLE_MS, () => {
      const distancesCalculator = new MostClosestToCenterCalculator();

      Object.values(refBlocksState).forEach(block => {
        /* istanbul ignore next */
        if (block && block.ref.current) {
          const isInViewport = isElementInViewport(block.ref.current, 0.9);

          if (isInViewport) {
            distancesCalculator.recalculate(block);
          }

          if (!viewed.includes(block.id) && isInViewport) {
            setViewed([...viewed, block.id]);
          }
        }
      });

      /**
       * Одновременно в вьюпорту может находиться несколько блоков (EScrollingBlocks)
       * В качестве текущего (active) устанавливаем самый близкий к центру экрана блок (из числа видимых)
       * Вычисляем этот блок с помощью класса MostClosestToCenterCalculator
       * */
      if (distancesCalculator.mostClosestToCenterBlock) {
        setActive(distancesCalculator.mostClosestToCenterBlock.id);
      }
    });

    window.addEventListener('scroll', handler);

    return () => window.removeEventListener('scroll', handler);
  }, [viewed, setViewed, refBlocksState, setActive]);
};
